
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexJvqASZRPmjX9v01MwIhMQqYFEFL8M132h14XvkjY1yoMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/index.vue?macro=true";
import { default as indexT2Ib9NDwh3s_45yu7KXFGQ_ZLvkmxMgezTLJ7EdkAMFm0Meta } from "/home/ubuntu/e_com_frontend/src/app/routes/faq/index.vue?macro=true";
import { default as indexmSkljWaPXZKhJ4fufah5mv82bL2ihekOYHumilAg5H0Meta } from "/home/ubuntu/e_com_frontend/src/app/routes/new/index.vue?macro=true";
import { default as indexvbytMmt3UKH4mJ4lf7J3VcVVDKJVIcH3ntYtBHWMPNMMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/cart/index.vue?macro=true";
import { default as index4_aWGU16bG7JUNcHkV3fMQxzPFCRhnZiyipewb9ndDgMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/sale/index.vue?macro=true";
import { default as indexX8ld_45wA6kNGsPexWk8AIC1dupo7wyBLeyavLHav4MCoMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/about/index.vue?macro=true";
import { default as indexHvHR1W730DGUcvmV_45LqoSBiUezzU_nX1Jep9fkV3YhEMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/catalog/index.vue?macro=true";
import { default as index6ld6S52JptjXN2svwuJp6FkZl6_tJO49O9o5RXObIZMMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/popular/index.vue?macro=true";
import { default as indexcyRx6CM0yUYD_45XlmMwb31dDLf_rN7f_45ktpjvN_45_qpSgMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/profile/index.vue?macro=true";
import { default as indexlksyHk222r1M3Z2lHOzIQzaHC7RF_45QzCkHoylAQq8ZUMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/contacts/index.vue?macro=true";
import { default as indexLBkfjFn_1J65FulJS6jv4NU2jYHiXeqZC9fpHNt6z80Meta } from "/home/ubuntu/e_com_frontend/src/app/routes/promotions/index.vue?macro=true";
import { default as indexFPW2tADobEwKn0a_lIDGdADLW1yGZGNipQ7o_45MylX44Meta } from "/home/ubuntu/e_com_frontend/src/app/routes/liquidation/index.vue?macro=true";
import { default as indexFl3lQTadB_WjukrChT_45epXgIKA5XouxFpjBRF_45A2eLwMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/for-business/index.vue?macro=true";
import { default as indexcOTdYZcIqbocuJSD3sXqYUaCGwXHRRy2o62IjiFBKb8Meta } from "/home/ubuntu/e_com_frontend/src/app/routes/pickup-points/index.vue?macro=true";
import { default as indexFLNCnYWCwctSMMeNBmr0OiHmtWAXwlOMhzqk3FC8aRUMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/index.vue?macro=true";
import { default as indexVKakvpiXabCgR294ExW6L_45luZzAkBxzafIJO3jiF0TMMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/delivery-payment/index.vue?macro=true";
import { default as indexJYLEBiWh_bj39boPAudIlsZghjlwx2_45aWZ891B7gb7MMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/profile/favorites/index.vue?macro=true";
import { default as indexdNzYB1LGVze1KMCwuLYoHtjT_45eGnIeGHRrpMpMgtRhwMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/index.vue?macro=true";
import { default as _91orderId_93ReUzgrr_456KL2pwbNn4_m6qANZE6tf62qEgYK4tflghMMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/[orderId].vue?macro=true";
import { default as indexJ9XjEKshy3UqWTsYom7qSUX6XrrUEKCPfFNVsMFK_fsMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/index.vue?macro=true";
import { default as index2iZ5_6AfHbAEJG3jF0vcHgMdrLbhm2uGImAgzdfrSugMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/product-[product]/index.vue?macro=true";
import { default as indexLhM1P6wuMn6oTM1k3RQP7PW_7S_j5jcqftumcIVesbsMeta } from "/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/product-[product]/index.vue?macro=true";
export default [
  {
    name: "index___ru",
    path: "/",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/index.vue")
  },
  {
    name: "index___uz",
    path: "/uz",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/index.vue")
  },
  {
    name: "faq___ru",
    path: "/faq",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/faq/index.vue")
  },
  {
    name: "faq___uz",
    path: "/uz/faq",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/faq/index.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/faq/index.vue")
  },
  {
    name: "new___ru",
    path: "/new",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/new/index.vue")
  },
  {
    name: "new___uz",
    path: "/uz/new",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/new/index.vue")
  },
  {
    name: "new___en",
    path: "/en/new",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/new/index.vue")
  },
  {
    name: "cart___ru",
    path: "/cart",
    meta: indexvbytMmt3UKH4mJ4lf7J3VcVVDKJVIcH3ntYtBHWMPNMMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/cart/index.vue")
  },
  {
    name: "cart___uz",
    path: "/uz/cart",
    meta: indexvbytMmt3UKH4mJ4lf7J3VcVVDKJVIcH3ntYtBHWMPNMMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/cart/index.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    meta: indexvbytMmt3UKH4mJ4lf7J3VcVVDKJVIcH3ntYtBHWMPNMMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/cart/index.vue")
  },
  {
    name: "sale___ru",
    path: "/sale",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/sale/index.vue")
  },
  {
    name: "sale___uz",
    path: "/uz/sale",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/sale/index.vue")
  },
  {
    name: "sale___en",
    path: "/en/sale",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/sale/index.vue")
  },
  {
    name: "about___ru",
    path: "/about",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/about/index.vue")
  },
  {
    name: "about___uz",
    path: "/uz/about",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/about/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/about/index.vue")
  },
  {
    name: "catalog___ru",
    path: "/catalog",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/index.vue")
  },
  {
    name: "catalog___uz",
    path: "/uz/catalog",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/index.vue")
  },
  {
    name: "catalog___en",
    path: "/en/catalog",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/index.vue")
  },
  {
    name: "popular___ru",
    path: "/popular",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/popular/index.vue")
  },
  {
    name: "popular___uz",
    path: "/uz/popular",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/popular/index.vue")
  },
  {
    name: "popular___en",
    path: "/en/popular",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/popular/index.vue")
  },
  {
    name: "profile___ru",
    path: "/profile",
    meta: indexcyRx6CM0yUYD_45XlmMwb31dDLf_rN7f_45ktpjvN_45_qpSgMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/index.vue")
  },
  {
    name: "profile___uz",
    path: "/uz/profile",
    meta: indexcyRx6CM0yUYD_45XlmMwb31dDLf_rN7f_45ktpjvN_45_qpSgMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/index.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: indexcyRx6CM0yUYD_45XlmMwb31dDLf_rN7f_45ktpjvN_45_qpSgMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/index.vue")
  },
  {
    name: "contacts___ru",
    path: "/contacts",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/contacts/index.vue")
  },
  {
    name: "contacts___uz",
    path: "/uz/contacts",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/contacts/index.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/contacts/index.vue")
  },
  {
    name: "promotions___ru",
    path: "/promotions",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/promotions/index.vue")
  },
  {
    name: "promotions___uz",
    path: "/uz/promotions",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/promotions/index.vue")
  },
  {
    name: "promotions___en",
    path: "/en/promotions",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/promotions/index.vue")
  },
  {
    name: "liquidation___ru",
    path: "/liquidation",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/liquidation/index.vue")
  },
  {
    name: "liquidation___uz",
    path: "/uz/liquidation",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/liquidation/index.vue")
  },
  {
    name: "liquidation___en",
    path: "/en/liquidation",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/liquidation/index.vue")
  },
  {
    name: "for-business___ru",
    path: "/for-business",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/for-business/index.vue")
  },
  {
    name: "for-business___uz",
    path: "/uz/for-business",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/for-business/index.vue")
  },
  {
    name: "for-business___en",
    path: "/en/for-business",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/for-business/index.vue")
  },
  {
    name: "pickup-points___ru",
    path: "/pickup-points",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/pickup-points/index.vue")
  },
  {
    name: "pickup-points___uz",
    path: "/uz/pickup-points",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/pickup-points/index.vue")
  },
  {
    name: "pickup-points___en",
    path: "/en/pickup-points",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/pickup-points/index.vue")
  },
  {
    name: "profile-orders___ru",
    path: "/profile/orders",
    meta: indexFLNCnYWCwctSMMeNBmr0OiHmtWAXwlOMhzqk3FC8aRUMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/index.vue")
  },
  {
    name: "profile-orders___uz",
    path: "/uz/profile/orders",
    meta: indexFLNCnYWCwctSMMeNBmr0OiHmtWAXwlOMhzqk3FC8aRUMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/index.vue")
  },
  {
    name: "profile-orders___en",
    path: "/en/profile/orders",
    meta: indexFLNCnYWCwctSMMeNBmr0OiHmtWAXwlOMhzqk3FC8aRUMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/index.vue")
  },
  {
    name: "delivery-payment___ru",
    path: "/delivery-payment",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/delivery-payment/index.vue")
  },
  {
    name: "delivery-payment___uz",
    path: "/uz/delivery-payment",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/delivery-payment/index.vue")
  },
  {
    name: "delivery-payment___en",
    path: "/en/delivery-payment",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/delivery-payment/index.vue")
  },
  {
    name: "profile-favorites___ru",
    path: "/profile/favorites",
    meta: indexJYLEBiWh_bj39boPAudIlsZghjlwx2_45aWZ891B7gb7MMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/favorites/index.vue")
  },
  {
    name: "profile-favorites___uz",
    path: "/uz/profile/favorites",
    meta: indexJYLEBiWh_bj39boPAudIlsZghjlwx2_45aWZ891B7gb7MMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/favorites/index.vue")
  },
  {
    name: "profile-favorites___en",
    path: "/en/profile/favorites",
    meta: indexJYLEBiWh_bj39boPAudIlsZghjlwx2_45aWZ891B7gb7MMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/favorites/index.vue")
  },
  {
    name: "catalog-category___ru",
    path: "/catalog/:category()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/index.vue")
  },
  {
    name: "catalog-category___uz",
    path: "/uz/catalog/:category()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/index.vue")
  },
  {
    name: "catalog-category___en",
    path: "/en/catalog/:category()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/index.vue")
  },
  {
    name: "profile-orders-orderId___ru",
    path: "/profile/orders/:orderId()",
    meta: _91orderId_93ReUzgrr_456KL2pwbNn4_m6qANZE6tf62qEgYK4tflghMMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/[orderId].vue")
  },
  {
    name: "profile-orders-orderId___uz",
    path: "/uz/profile/orders/:orderId()",
    meta: _91orderId_93ReUzgrr_456KL2pwbNn4_m6qANZE6tf62qEgYK4tflghMMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/[orderId].vue")
  },
  {
    name: "profile-orders-orderId___en",
    path: "/en/profile/orders/:orderId()",
    meta: _91orderId_93ReUzgrr_456KL2pwbNn4_m6qANZE6tf62qEgYK4tflghMMeta || {},
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/profile/orders/[orderId].vue")
  },
  {
    name: "catalog-category-subcategory___ru",
    path: "/catalog/:category()/:subcategory()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/index.vue")
  },
  {
    name: "catalog-category-subcategory___uz",
    path: "/uz/catalog/:category()/:subcategory()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/index.vue")
  },
  {
    name: "catalog-category-subcategory___en",
    path: "/en/catalog/:category()/:subcategory()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/index.vue")
  },
  {
    name: "catalog-category-product-product___ru",
    path: "/catalog/:category()/product-:product()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/product-[product]/index.vue")
  },
  {
    name: "catalog-category-product-product___uz",
    path: "/uz/catalog/:category()/product-:product()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/product-[product]/index.vue")
  },
  {
    name: "catalog-category-product-product___en",
    path: "/en/catalog/:category()/product-:product()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/product-[product]/index.vue")
  },
  {
    name: "catalog-category-subcategory-product-product___ru",
    path: "/catalog/:category()/:subcategory()/product-:product()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/product-[product]/index.vue")
  },
  {
    name: "catalog-category-subcategory-product-product___uz",
    path: "/uz/catalog/:category()/:subcategory()/product-:product()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/product-[product]/index.vue")
  },
  {
    name: "catalog-category-subcategory-product-product___en",
    path: "/en/catalog/:category()/:subcategory()/product-:product()",
    component: () => import("/home/ubuntu/e_com_frontend/src/app/routes/catalog/[category]/[subcategory]/product-[product]/index.vue")
  }
]